/**
 * YourStoreFacetCio — Store Availability Facet Module
 * Extracted from constructor-listing.js
 *
 * This standalone class handles the "Your Store" facet component
 * for filtering products by store availability (pickup, view in store, shipping).
 */

/* ═══════════════════════════════════════════════════════════════
   CLASS — YourStoreFacetCio (standalone)
   ═══════════════════════════════════════════════════════════════ */
class YourStoreFacetCio extends HTMLElement {
    constructor() {
        super();

        this.yourStoreModalOpener = document.querySelectorAll('.your-store-modal__button');
        this.yourStoreModal = document.querySelector('your-store-modal');
        this.currentStoreEl = this.querySelector('.facet-way__current');
        this.loadingIndicator = this.querySelector('.facet-store-selector__loader');
        this.isInitialized = false;

        this.setLocalData();
    }

    setLocalData() {
        this.way = localStorage.getItem('storeWay') || 'all';
        this.state = localStorage.getItem('storeState') || 'MN';
        this.store = localStorage.getItem('storeLocation') || null;
        this.availability = localStorage.getItem('storeAvailability') || null;
    }

    connectedCallback() {
        this.mobileDrawer = this.closest('.mobile-facets__drawer') || this.closest('menu-drawer');
        this.syncAvailability();
    }

    syncAvailability() {
        if (!p80.facetAvailabilityCounts) return;

        if (!this.isInitialized) {
            this.wayButtons = Array.from(this.querySelectorAll('[name="facet-way"]'));
            this.wayButtons.forEach((button) => {
                button.addEventListener('click', this.handleWayClick.bind(this));
            });
            this.initHiddenFilters();
            this.isInitialized = true;
        }

        this.setFacetCounts();
        this.setActiveWayInFacet();
        this.hideLoadingIndicator();
    }

    refreshCounts() {
        this.syncAvailability();
    }

    initHiddenFilters() {
        this.shopOnlineFilter = document.querySelector('details[data-name="pickup_in_store"]');
        this.viewInStoreFilter = document.querySelector('details[data-name="view_in_store"]');
        this.shippableFilter = document.querySelector(
            'details[data-name="shippable_quantity_boolean"]'
        );
        this.currentlyWayEl = this.querySelector('.facet-way__current');

        if (this.currentlyWayEl && this.yourStoreModalOpener) {
            this.currentlyWayEl.addEventListener(
                'click',
                function () {
                    this.yourStoreModalOpener[0].click();
                    if (this.yourStoreModal)
                        this.yourStoreModal.querySelector('button[data-way="pickup"]').click();
                }.bind(this)
            );
        }

        this.availabilityRadiosWrapper = this.querySelector('.facet-way__sub-options');
        this.availabilityRadios = Array.from(this.querySelectorAll('[data-store-availability]'));
        this.availabilityRadios.forEach((radioButton) => {
            radioButton.addEventListener('click', this.handleAvailabilityClick.bind(this));
        });

        this.currentlySelectedStoreWayEl = this.querySelector('[data-facet-current-store]');
    }

    setSelectedStoreInFacet() {
        const headerModalOpener = document.querySelector('.header__your-store-opener');
        if (!headerModalOpener) return;

        const storeName = localStorage.getItem('storeLocation');
        const storeStatus =
            headerModalOpener.querySelector('.your-store-status')?.textContent || '';

        const allStoreFacet = Array.from(document.querySelectorAll('your-store-facet-cio'));
        allStoreFacet.forEach((facet) => {
            const storeNameEl = facet.querySelector('[data-facet-current-store]');
            const yourStoreNameEl = facet.querySelector('.your-store-name');
            const yourStoreStatusEl = facet.querySelector('.your-store-status');
            if (storeNameEl) storeNameEl.textContent = storeName;
            if (yourStoreNameEl) yourStoreNameEl.textContent = storeName;
            if (yourStoreStatusEl) {
                yourStoreStatusEl.dataset.status = storeStatus;
                yourStoreStatusEl.textContent = storeStatus;
            }
        });
    }

    setFacetCounts() {
        this.setLocalData();

        const facetShopAllCount = this.querySelector('span[data-facet-shop-all]');
        const facetShipToYouCount = this.querySelector('span[data-facet-ship-to-you]');
        const facetPickupCount = this.querySelector('span[data-facet-pickup]');
        const facetViewCount = this.querySelector('span[data-facet-view]');
        const facetYourStoreCount = this.querySelector('span[data-facet-your-store]');
        const counts = p80.facetAvailabilityCounts || {};
        const shopAllCount = counts['facet-shop-all'] || 0;
        const shipToYouCount = counts['facet-ship-to-you'] || 0;
        const pickupCounts = counts['facet-pickup'] || {};
        const viewCounts = counts['facet-view'] || {};
        const selectedStore = this.store;
        const pickupCount = selectedStore ? pickupCounts[selectedStore] || 0 : 0;
        const viewCount = selectedStore ? viewCounts[selectedStore] || 0 : 0;

        const setCount = (el, value) => {
            if (!el) return;
            el.textContent = '(' + value + ')';
        };

        if (this.way === 'pickup' && this.store) {
            setCount(facetYourStoreCount, pickupCount);
        } else if (this.way === 'view' && this.store) {
            setCount(facetYourStoreCount, viewCount);
        } else {
            setCount(facetYourStoreCount, shopAllCount);
        }

        setCount(facetShopAllCount, shopAllCount);
        setCount(facetShipToYouCount, shipToYouCount);
        setCount(facetPickupCount, pickupCount);
        setCount(facetViewCount, viewCount);

        this.hideLoadingIndicator();
    }

    handleWayClick(event) {
        const buttonEl = event.target;

        if (buttonEl.value === 'all' || buttonEl.value === 'online') {
            this.applyAvailabilityFilter(buttonEl.value);
            this.way = buttonEl.value;

            const headerModalOpener = document.querySelector('.header__your-store-opener');
            if (headerModalOpener) {
                headerModalOpener.querySelector('button')?.setAttribute('data-way', this.way);
            }

            if (this.way === 'online') {
                localStorage.setItem('storeWay', 'online');
                localStorage.removeItem('storeAvailability');
                localStorage.removeItem('storeState');
            } else {
                localStorage.setItem('storeWay', 'all');
            }

            if (this.yourStoreModal) this.yourStoreModal.showSuccessNotice?.();
            this.closeMobileDrawer();
        } else if (
            buttonEl.value === 'pickup' &&
            this.yourStoreModalOpener.length &&
            this.yourStoreModal
        ) {
            if (!this.store) {
                this.yourStoreModalOpener[0].click();
                this.yourStoreModal.querySelector('button[data-way="pickup"]').click();
            } else {
                this.yourStoreModal.querySelector('button[data-way="pickup"]').click();
                const storeBtn = this.yourStoreModal.querySelector(
                    '[data-pickup-store][value="' + this.store + '"]'
                );
                if (storeBtn) storeBtn.click();
            }
        }
    }

    applyAvailabilityFilter(type, store = null) {
        const uncheckAll = (filterEl) => {
            if (!filterEl) return;
            const checked = Array.from(filterEl.querySelectorAll('input[type="checkbox"]:checked'));
            checked.forEach((input) => {
                input.checked = false;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            });
        };

        const clickOptionByValue = (filterEl, value) => {
            if (!filterEl) return;
            const input = filterEl.querySelector('input[value="' + value + '"]');
            if (input) {
                input.checked = true;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        };

        const clickLastOption = (filterEl) => {
            if (!filterEl) return;
            const inputs = Array.from(filterEl.querySelectorAll('input[type="checkbox"]'));
            const last = inputs[inputs.length - 1];
            if (last) {
                last.checked = false;
                last.dispatchEvent(new Event('change', { bubbles: true }));
            }
        };

        switch (type) {
            case 'all':
                uncheckAll(this.shopOnlineFilter);
                uncheckAll(this.viewInStoreFilter);
                uncheckAll(this.shippableFilter);
                clickLastOption(this.shippableFilter);
                break;
            case 'online':
                uncheckAll(this.shopOnlineFilter);
                uncheckAll(this.viewInStoreFilter);
                clickOptionByValue(this.shippableFilter, 'True');
                break;
            case 'pickup':
                uncheckAll(this.shippableFilter);
                uncheckAll(this.viewInStoreFilter);
                clickOptionByValue(this.shopOnlineFilter, store || this.store);
                break;
            case 'view':
                uncheckAll(this.shippableFilter);
                uncheckAll(this.shopOnlineFilter);
                clickOptionByValue(this.viewInStoreFilter, store || this.store);
                break;
            default:
                console.warn('applyAvailabilityFilter: unknown type "' + type + '"');
        }
    }

    setActiveWayInFacet() {
        this.way = localStorage.getItem('storeWay') || 'all';

        this.wayButtons.forEach((button) => {
            button.checked = button.value === this.way;
        });

        if (this.way !== 'pickup' && this.way !== 'view') return;
        if (this.currentlySelectedStoreWayEl)
            this.currentlySelectedStoreWayEl.textContent = this.store;

        if (!this.availability) return;
        this.querySelector('.active-option')?.classList.remove('active-option');
        const activeRadio = this.querySelector(
            '.facet-way__radio[data-store-availability="' + this.availability + '"]'
        );
        if (activeRadio) activeRadio.classList.add('active-option');

        this.setSelectedStoreInFacet();
    }

    handleAvailabilityClick(event) {
        const availabilityButton = event.target;
        const storeAvailability = availabilityButton.dataset.storeAvailability;

        localStorage.setItem('storeAvailability', storeAvailability);
        this.applyAvailabilityFilter(storeAvailability, this.store);
        this.closeMobileDrawer();
    }

    hideLoadingIndicator() {
        setTimeout(() => {
            if (this.loadingIndicator) this.loadingIndicator.classList.remove('visible');
        }, 500);
    }

    closeMobileDrawer() {
        const menuDrawer =
            document.querySelector('menu-drawer') ||
            document.querySelector('.mobile-facets__wrapper');
        if (!menuDrawer) return;

        const summary =
            menuDrawer.querySelector('summary.mobile-facets__open-wrapper') ||
            menuDrawer.querySelector('summary[aria-expanded="true"]');

        if (summary) summary.click();
    }
}

/* ═══════════════════════════════════════════════════════════════
   REGISTER CUSTOM ELEMENT
   ═══════════════════════════════════════════════════════════════ */
if (!customElements.get('your-store-facet-cio')) {
    customElements.define('your-store-facet-cio', YourStoreFacetCio);
}
